import { useCallback, useState } from 'react';

const COPIED_RESET_DELAY_MS = 1500;

/**
 * Copies the string returned by `getText` to the clipboard on `copy()`,
 * flipping `copied` true for a short window so a button can show a
 * "Copied" confirmation.
 */
export const useCopyToClipboard = (
  getText: () => string
): { copied: boolean; copy: () => void } => {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(() => {
    navigator.clipboard.writeText(getText()).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_RESET_DELAY_MS);
    });
  }, [getText]);

  return { copied, copy };
};
